export const getSequence = (length, startAt = 0) => {
  // https://stackoverflow.com/a/33352604
  return Array.from({ length }, (_, i) => i + startAt);
};

